import { React, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./_layout/_Header";
import Footer from "./_layout/_Footer";
import ProgressSimple from "./_layout/_ProgressSimple";
import BeginForm from "./components/_BeginForm";
import About from "./components/_About";
import Detail from "./components/_Detail";
import Submit from "./components/_Submit";
import ReasonForReferral from "./components/_ReasonForReferral";
import Confirm from "./components/_Confirm";
import ErrorPage from "./components/_ErrorPage";
import A11yStatement from "./components/_A11yStatement";
import { BetaBanner } from "./_layout/_BetaBanner";

import './styles/App.scss';


function App() {

  useEffect(() => {
    const evTypep = window.performance.getEntriesByType("navigation")[0].type;
    if (evTypep === "reload") {
      window.location.replace("/");
    }
  }, []);

  return (
    <Router>
      <div className="App">
        <Header />
        <BetaBanner />
				<ProgressSimple />
        <Routes>
          <Route path="/index.html" element={<BeginForm />}></Route>
          <Route path="/" element={<BeginForm />}></Route>
          <Route path="/aboutyou" element={<About />}></Route>
          <Route path="/details" element={<Detail />}></Route>
          <Route path="/reason-for-referral" element={<ReasonForReferral />}></Route>
          <Route path="/submit" element={<Submit />}></Route>
          <Route path="/confirm" element={<Confirm />}></Route>
          <Route path="/*" element={<ErrorPage />}></Route>
					<Route path="/accessibility-statement" element={<A11yStatement />}></Route>
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
